import { ReactNode } from 'react';

import { DatetimeShow } from '@fhs/ui';

import {
  captainsClubEndDate,
  captainsClubStartDate,
  poweradeVictoryBundleEndDate,
  poweradeVictoryBundleStartDate,
} from '../constants';

export type LtoContentProps = {
  poweradeVictoryBundleContent?: ReactNode;
  captainsClubContent?: ReactNode;
};

export const LtoContentUS = ({
  captainsClubContent,
  poweradeVictoryBundleContent,
}: LtoContentProps) => {
  return (
    <>
      <DatetimeShow after={poweradeVictoryBundleStartDate} before={poweradeVictoryBundleEndDate}>
        {poweradeVictoryBundleContent}
      </DatetimeShow>
      <DatetimeShow after={captainsClubStartDate} before={captainsClubEndDate}>
        {captainsClubContent}
      </DatetimeShow>
    </>
  );
};
